import api from './api.service';

export default {
    createCustomer(data) {
        return api.post('/customer/customers', data);
    },
    getAllCustomers(companyId) {
        const url = companyId ? `/customer/customers?companyId=${companyId}` : '/customer/customers';
        return api.get(url);
    },
    getCustomerById(id, companyId) {
        return api.get(`/customer/customers/${id}?companyId=${companyId}`);
    },
    updateCustomer(id, data) {
        return api.put(`/customer/customers/${id}`, data);
    },
    deleteCustomer(id) {
        return api.delete(`/customer/customers/${id}`);
    },
    checkCustomerIdExists(customerId, companyId, excludeId = null) {
        let url = `/customer/customers/check-id?customerId=${customerId}&companyId=${companyId}`;
        if (excludeId) {
            url += `&excludeId=${excludeId}`;
        }
        return api.get(url);
    },
    checkCustomerNameExists(customerName, companyId) {
        return api.get(`/customer/customers/check-name?customerName=${encodeURIComponent(customerName)}&companyId=${companyId}`);
    },
    checkConsultantIdExists(consultantId, companyId, excludeId = null) {
        let url = `/customer/consultants/check-id?consultantId=${consultantId}&companyId=${companyId}`;
        if (excludeId) {
            url += `&excludeId=${excludeId}`;
        }
        return api.get(url);
    },
    checkContactEmailExists(email, companyId, excludeCustomerId = null) {
        let url = `/customer/customers/check-contact-email?email=${encodeURIComponent(email)}&companyId=${companyId}`;
        if (excludeCustomerId) {
            url += `&excludeCustomerId=${excludeCustomerId}`;
        }
        return api.get(url);
    },
    // Customer Document methods
    uploadCustomerDocuments(customerId, companyId, formData) {
        return api.post(`/customer/customers/documents?customerId=${customerId}&companyId=${companyId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getCustomerDocuments(customerId, companyId) {
        return api.get(`/customer/customers/documents?customerId=${customerId}&companyId=${companyId}`);
    },
    getCustomerDocumentById(id, companyId) {
        return api.get(`/customer/customers/documents/${id}?companyId=${companyId}`);
    },
    viewCustomerDocument(id, companyId) {
        return api.get(`/customer/customers/documents/${id}/view?companyId=${companyId}`, {
            responseType: 'blob'
        });
    },
    updateCustomerDocument(id, companyId, data) {
        return api.put(`/customer/customers/documents/${id}?companyId=${companyId}`, data);
    },
    deleteCustomerDocument(id, companyId) {
        return api.delete(`/customer/customers/documents/${id}?companyId=${companyId}`);
    }
}; 